import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import {
    ETLReportingSetDateOperationTypes,
    ETLReportingSetDropdownOptions,
    ETLReportingSetUnitsOptions,
    ETLReportingSetReturnTypes
} from "../../../cxone-etl-reporting-set.model";

@Component({
    selector: "cv-cxone-reporting-set-complex-date-field",
    templateUrl: "./cxone-reporting-set-complex-date-field.component.html",
    styleUrls: ["./cxone-reporting-set-complex-date-field.component.scss"],
})
export class CxoneReportingSetComplexDateFieldComponent implements OnInit, OnChanges {
    @Output() back = new EventEmitter();
    @Output() addChilds = new EventEmitter();
    @Output() editExistItem = new EventEmitter();
    @Output() formChanged = new EventEmitter();
    @Output() formNotChanged = new EventEmitter();
    @Output() validateSaveBtn = new EventEmitter();
    @Input() returnType: ETLReportingSetDropdownOptions;
    public _parentData: any;
    public toggleDateDifferenceView = true;
    public commonPlaceHolder = "";
    etlReportingSetDateOT = ETLReportingSetDateOperationTypes;
    _returnType: ETLReportingSetDropdownOptions;
    public complexDateForm = new FormGroup({
        operationDropdown: new FormControl(),
        leftOperandDate: new FormControl(),
        rightOperandDate: new FormControl(),
        unitsDropdown: new FormControl(),
        secondsUnitField: new FormControl(),
        minutesUnitField: new FormControl(),
        hoursUnitField: new FormControl(),
        daysUnitField: new FormControl(),
        monthUnitField: new FormControl(),
    });
    public operationTypes: ETLReportingSetDropdownOptions[] = [];
    public unitsOptions: ETLReportingSetDropdownOptions[] = [];
    constructor(private cvLocalizationService: CVLocalizationService,
        private formBuilder: FormBuilder) {
    }

    get operationDropdown(): ETLReportingSetDropdownOptions {
        return this.complexDateForm.get("operationDropdown").value;
    }
    get parentData() {
        return this._parentData;
    }

    @Input() set parentData(data) {
        this._parentData = data;
        if (this.complexDateForm && data?.operation) {
            this.complexDateForm.controls['operationDropdown'].setValue(data?.operation);
            this._parentData.isValid = this.checkIsValid();
        }
        this.initializeOperationTypes();
        if (this.complexDateForm && this.operationTypes.length && !data.hasOwnProperty('operation')) {
            this.setDefualtOperationValue();
        }
        this.setToggleDateDifferenceView();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.complexDateForm && this.operationTypes.length) {
            this.setDefualtOperationValue();
        }
    }

    setDefualtOperationValue() {
        if (this.returnType && this.returnType.id == ETLReportingSetReturnTypes.DATE) {
            this.complexDateForm.controls['operationDropdown'].setValue(this.operationTypes[0]);
        }
        if (this.returnType && this.returnType.id == ETLReportingSetReturnTypes.DECIMAL_NUMBER) {
            this.complexDateForm.controls['operationDropdown'].setValue(this.operationTypes[1]);
        }
    }

    async ngOnInit() {
        await this.loadLocalization();
        this.initializeOperationTypes();
        this.initializeUnitsOptions();
        this.initializeDefaultValues();
        if (this.parentData) {
            this.parentData.isValid = this.checkIsValid();
        }
    }

    public initializeDefaultValues() {
        if (this.complexDateForm.get("operationDropdown").value === '') {
            this.complexDateForm.get("operationDropdown").setValue(this.operationTypes[0]);
        }
        this.complexDateForm.get("unitsDropdown").setValue(this.unitsOptions[0]);

        this.setToggleDateDifferenceView();
    }

    public initializeOperationTypes() {
        this.operationTypes = [
            {
                id: ETLReportingSetDateOperationTypes.ADD_SUBTRACT_UNIT,
                label: "Add Subtract Unit",
            },
            {
                id: ETLReportingSetDateOperationTypes.DATE_DIFFERENCE,
                label: "Date Difference",
            },
        ];
    }
    public initializeUnitsOptions() {
        this.unitsOptions = [
            {
                id: ETLReportingSetUnitsOptions.MILLISECONDS,
                label: "Milliseconds",
            },
            {
                id: ETLReportingSetUnitsOptions.SECONDS,
                label: "Seconds",
            },
            {
                id: ETLReportingSetUnitsOptions.MINUTES,
                label: "Minutes",
            },
            {
                id: ETLReportingSetUnitsOptions.HOURS,
                label: "Hours",
            },
            {
                id: ETLReportingSetUnitsOptions.DAYS,
                label: "Days",
            },
            {
                id: ETLReportingSetUnitsOptions.MONTH,
                label: "Month",
            },
        ];
    }
    async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection("ETL_Reporting_Set");
        } catch {
            console.log("Failed to load localization for ETL_Reporting_Set");
        } finally {
            this.commonPlaceHolder = this.getLocalizationString(
                "Add_Value",
                "Add Value"
            );
        }
    }
    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText(
            "ETL_Reporting_Set",
            key,
            defaultValue
        );
        return baseString;
    }

    setToggleDateDifferenceView(isDropdownChanged = false) {
        if (this.operationDropdown?.id === this.etlReportingSetDateOT.DATE_DIFFERENCE) {
            this.toggleDateDifferenceView = true;
            if (isDropdownChanged) {
                this._parentData['rightOperand'] = [];
                this._parentData['seconds'] = [];
                this._parentData['minutes'] = [];
                this._parentData['hours'] = [];
                this._parentData['days'] = [];
                this._parentData['hours'] = [];
                this._parentData['days'] = [];
                this._parentData['months'] = [];
            }
        } else if (this.operationDropdown?.id === this.etlReportingSetDateOT.ADD_SUBTRACT_UNIT) {
            this.toggleDateDifferenceView = false;
        }
        this._parentData.operation = this.operationDropdown;
        if (isDropdownChanged === false) {
            this.formNotChanged.emit(this._parentData);
        } else {
            this.formChanged.emit(this._parentData);
        }
    }

    public addNewField(operand): void {
        this._parentData.operand = operand;
        this._parentData[operand] = [];
        this.addChilds.emit(this._parentData);
        this.formChanged.emit(this._parentData);
    }
    public editInput(item) {
        this.editExistItem.emit(item);
    }

    public checkIsValid() {
        if (this.parentData?.operation?.hasOwnProperty('id')) {
            if (this.parentData.operation.id != 0) {
                return this.complexDateForm.valid &&
                    (this.parentData.hasOwnProperty('leftOperand') && this.parentData.leftOperand.length > 0) &&
                    (this.parentData.hasOwnProperty('rightOperand') && this.parentData.rightOperand.length > 0) &&
                    (this.returnType && this.returnType.id == ETLReportingSetReturnTypes.DECIMAL_NUMBER);
            } else {
                return this.complexDateForm.valid &&
                    (this.parentData.hasOwnProperty('leftOperand') && this.parentData.leftOperand.length > 0) &&
                    (this.parentData.hasOwnProperty('days') && this.parentData.days.length > 0) &&
                    (this.parentData.hasOwnProperty('hours') && this.parentData.hours.length > 0) &&
                    (this.parentData.hasOwnProperty('minutes') && this.parentData.minutes.length > 0) &&
                    (this.parentData.hasOwnProperty('months') && this.parentData.months.length > 0) &&
                    (this.parentData.hasOwnProperty('seconds') && this.parentData.seconds.length > 0) &&
                    (this.returnType && this.returnType.id == ETLReportingSetReturnTypes.DATE);
            }
        } else {
            return this.complexDateForm.valid;
        }
    }

    unitsValueChange(isFromDropdown = false) {
        if (isFromDropdown) {
            this.formChanged.emit(this._parentData);
            this.validateSaveBtn.emit(this._parentData);
        }
    }
}
